import React from "react";

const MobileAnalyticsDashboard: React.FC = () => {
  return (
    <div className="relative w-full max-w-[380px] mx-auto">
      <style>{`
        @keyframes bar-grow {
          0% { transform: scaleY(0); opacity: 0; }
          100% { transform: scaleY(1); opacity: 1; }
        }
        @keyframes tooltip-fade {
          0% { opacity: 0; transform: translateY(5px); }
          100% { opacity: 1; transform: translateY(0); }
        }
        @keyframes progress-loop {
          0% { width: 0; opacity: 0.5; }
          40% { width: var(--target-width); opacity: 1; }
          80% { width: var(--target-width); opacity: 1; }
          100% { width: var(--target-width); opacity: 0; }
        }
        .no-scrollbar::-webkit-scrollbar { display: none; }
        .no-scrollbar { -ms-overflow-style: none; scrollbar-width: none; }
      `}</style>

      {/* Phone Frame */}
      <div
        className="border-[8px] border-[#222] overflow-hidden flex flex-col h-[720px] w-full max-w-[380px] ring-white/10 ring-1 rounded-[3rem] mx-auto relative shadow-2xl"
        style={{
          backgroundColor: "#0B1A27",
          backgroundImage:
            "radial-gradient(ellipse 80% 50% at 50% 0%, rgba(110, 231, 255, 0.16), transparent 60%), radial-gradient(ellipse 60% 40% at 50% 100%, rgba(31, 61, 86, 0.38), transparent 60%)",
        }}
      >
        {/* Status Bar */}
        <div className="h-12 w-full flex justify-between items-end px-8 pb-2 z-20 bg-transparent flex-shrink-0">
          <span className="text-[13px] font-semibold text-white tracking-widest">
            9:41
          </span>
          <div className="flex gap-1.5 items-center">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="12" viewBox="0 0 16 12" fill="currentColor" className="text-white">
              <path d="M14.6 2.4C14.2 2 13.5 2 13.1 2.4L8 7.5 2.9 2.4C2.5 2 1.8 2 1.4 2.4C1 2.8 1 3.5 1.4 3.9L7.3 9.8C7.7 10.2 8.3 10.2 8.7 9.8L14.6 3.9C15 3.5 15 2.8 14.6 2.4Z" />
              <path d="M12.4 0.2C12 0.6 12 1.3 12.4 1.7L8 6.1 3.6 1.7C4 1.3 4 0.6 3.6 0.2C3.2 -0.2 2.5 -0.2 2.1 0.2L7.3 5.4C7.7 5.8 8.3 5.8 8.7 5.4L13.9 0.2C13.5 -0.2 12.8 -0.2 12.4 0.2Z" />
              <path d="M8 8.2C8.4 8.2 8.7 8.5 8.7 8.9C8.7 9.3 8.4 9.6 8 9.6C7.6 9.6 7.3 9.3 7.3 8.9C7.3 8.5 7.6 8.2 8 8.2Z" />
            </svg>
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="12" viewBox="0 0 18 12" fill="currentColor" className="text-white">
              <path d="M15 2H3C1.3 2 0 3.3 0 5V7C0 8.7 1.3 10 3 10H15C16.7 10 18 8.7 18 7V5C18 3.3 16.7 2 15 2ZM3 3H15C16.1 3 17 3.9 17 5V7C17 8.1 16.1 9 15 9H3C1.9 9 1 8.1 1 7V5C1 3.9 1.9 3 3 3Z" />
              <path d="M11.5 4H6.5C5.7 4 5 4.7 5 5.5V6.5C5 7.3 5.7 8 6.5 8H11.5C12.3 8 13 7.3 13 6.5V5.5C13 4.7 12.3 4 11.5 4Z" />
            </svg>
            <div className="w-6 h-3 rounded-[4px] border border-white/30 relative ml-0.5 p-0.5">
              <div className="h-full rounded-[2px] w-full" style={{ backgroundColor: "#FFFFFF" }}></div>
            </div>
          </div>
        </div>

        {/* Header */}
        <div className="px-6 pt-2 pb-4 flex items-center justify-between z-10 bg-transparent flex-shrink-0">
          <h1 className="text-2xl text-white font-light tracking-tight">Statistics</h1>
          <div className="flex items-center gap-4">
            <button className="text-white hover:text-gray-300 transition-colors">
              <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9" />
                <path d="M10.3 21a1.94 1.94 0 0 0 3.4 0" />
              </svg>
            </button>
            <button 
  className="w-9 h-9 rounded-full flex items-center justify-center text-white transition-colors"
  style={{ backgroundColor: '#27272A' }}
>
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M5 12h14" />
                <path d="M12 5v14" />
              </svg>
            </button>
          </div>
        </div>

        {/* Scrollable Content */}
        <div className="flex-1 overflow-y-auto no-scrollbar px-5 pb-[120px]">
          {/* Chart Card */}
          <div className="overflow-visible border-white/[0.08] border rounded-[2rem] mb-6 p-5 relative shadow-2xl" style={{ backgroundColor: "#1C1C1C" }}>
            <div className="absolute top-0 right-0 w-full h-full bg-gradient-to-br from-indigo-500/5 via-transparent to-blue-500/5 rounded-[2rem] pointer-events-none"></div>

            <div className="flex justify-between items-start mb-8 relative z-10">
              <div>
                <h2 className="text-xl font-semibold text-white tracking-tight">Summer Festival 2026</h2>
                <p className="text-[13px] text-gray-400 mt-1 font-medium">Live API</p>
              </div>
              <div className="flex items-center gap-2 mt-1">
                <div className="w-2.5 h-2.5 rounded-full bg-blue-500 shadow-[0_0_8px_rgba(59,130,246,0.8)] animate-pulse"></div>
                <span className="text-[11px] font-medium text-gray-400">Overall - 80%</span>
              </div>
            </div>

            <div className="relative h-64 w-full pl-6">
              {/* Y-axis labels */}
              <div className="absolute left-0 top-0 h-full flex flex-col justify-between text-[11px] text-gray-500 font-medium pb-8 pt-2">
                <span>100</span>
                <span>75</span>
                <span>50</span>
                <span>25</span>
                <span>0</span>
              </div>

              {/* Grid lines */}
              <div className="absolute left-8 right-0 top-0 h-full flex flex-col justify-between pb-8 pt-2 pointer-events-none">
                <div className="w-full h-px border-t border-dashed border-white/10"></div>
                <div className="w-full h-px border-t border-dashed border-white/10"></div>
                <div className="w-full h-px border-t border-dashed border-white/10"></div>
                <div className="w-full h-px border-t border-dashed border-white/10"></div>
                <div className="w-full h-px border-t border-dashed border-white/10"></div>
              </div>

              {/* Bars */}
              <div className="flex justify-between items-end h-full pl-3 pb-8 relative z-10">
                {/* Bar 1 */}
                <div className="flex flex-col items-center gap-3 w-1/4 group cursor-pointer relative h-full justify-end">
                  <div
                    className="border border-white/10 rounded-lg py-1.5 px-2.5 mb-1 absolute -top-4 shadow-xl z-20 opacity-0"
                    style={{ backgroundColor: "#1A1A24", animation: "tooltip-fade 0.5s ease-out forwards 0.8s" }}
                  >
                    <div className="text-[11px] font-semibold text-white text-center leading-tight">
                      80% <span className="text-gray-400 font-medium">46K</span>
                    </div>
                  </div>
                  <div
                    className="w-12 h-[75%] bg-gradient-to-b from-[#4F46E5] to-[#4F46E5]/10 rounded-t-lg relative overflow-hidden group-hover:brightness-110 transition-all origin-bottom opacity-0"
                    style={{ animation: "bar-grow 0.8s cubic-bezier(0.34, 1.56, 0.64, 1) forwards 0.1s" }}
                  >
                    <div className="absolute top-0 left-0 w-full h-[40%] bg-gradient-to-b from-white/10 to-transparent"></div>
                  </div>
                  <span className="text-[10px] text-gray-400 font-medium whitespace-nowrap absolute -bottom-6">Scanned</span>
                </div>

                {/* Bar 2 */}
                <div className="flex flex-col items-center gap-3 w-1/4 group cursor-pointer relative h-full justify-end">
                  <div
                    className="border border-white/10 rounded-lg py-1.5 px-2.5 mb-1 absolute -top-4 shadow-xl z-20 opacity-0"
                    style={{ backgroundColor: "#1A1A24", animation: "tooltip-fade 0.5s ease-out forwards 0.9s" }}
                  >
                    <div className="text-[11px] font-semibold text-white text-center leading-tight">
                      60% <span className="text-gray-400 font-medium">27K</span>
                    </div>
                  </div>
                  <div
                    className="w-12 h-[60%] bg-gradient-to-b from-[#EC4899] via-[#F472B6] to-[#EC4899]/10 rounded-t-lg relative overflow-hidden group-hover:brightness-110 transition-all origin-bottom opacity-0"
                    style={{ animation: "bar-grow 0.8s cubic-bezier(0.34, 1.56, 0.64, 1) forwards 0.2s" }}
                  >
                    <div className="absolute top-0 left-0 w-full h-[40%] bg-gradient-to-b from-white/10 to-transparent"></div>
                  </div>
                  <span className="text-[10px] text-gray-400 font-medium whitespace-nowrap absolute -bottom-6">Female</span>
                </div>

                {/* Bar 3 */}
                <div className="flex flex-col items-center gap-3 w-1/4 group cursor-pointer relative h-full justify-end">
                  <div
                    className="border border-white/10 rounded-lg py-1.5 px-2.5 mb-1 absolute -top-4 shadow-xl z-20 opacity-0"
                    style={{ backgroundColor: "#1A1A24", animation: "tooltip-fade 0.5s ease-out forwards 1.0s" }}
                  >
                    <div className="text-[11px] font-semibold text-white text-center leading-tight">
                      40% <span className="text-gray-400 font-medium">19K</span>
                    </div>
                  </div>
                  <div
                    className="w-12 h-[40%] bg-gradient-to-b from-[#3B82F6] via-[#60A5FA] to-[#3B82F6]/10 rounded-t-lg relative overflow-hidden group-hover:brightness-110 transition-all origin-bottom opacity-0"
                    style={{ animation: "bar-grow 0.8s cubic-bezier(0.34, 1.56, 0.64, 1) forwards 0.3s" }}
                  >
                    <div className="absolute top-0 left-0 w-full h-[40%] bg-gradient-to-b from-white/10 to-transparent"></div>
                  </div>
                  <span className="text-[10px] text-gray-400 font-medium whitespace-nowrap absolute -bottom-6">Male</span>
                </div>

                {/* Bar 4 */}
                <div className="flex flex-col items-center gap-3 w-1/4 group cursor-pointer relative h-full justify-end">
                  <div
                    className="border border-white/10 rounded-lg py-1.5 px-2.5 mb-1 absolute -top-4 shadow-xl z-20 opacity-0"
                    style={{ backgroundColor: "#1A1A24", animation: "tooltip-fade 0.5s ease-out forwards 1.1s" }}
                  >
                    <div className="text-[11px] font-semibold text-white text-center leading-tight">
                      66% <span className="text-gray-400 font-medium">30K</span>
                    </div>
                  </div>
                  <div
                    className="w-12 h-[66%] bg-gradient-to-b from-[#14B8A6] via-[#2DD4BF] to-[#14B8A6]/10 rounded-t-lg relative overflow-hidden group-hover:brightness-110 transition-all origin-bottom opacity-0"
                    style={{ animation: "bar-grow 0.8s cubic-bezier(0.34, 1.56, 0.64, 1) forwards 0.4s" }}
                  >
                    <div className="absolute top-0 left-0 w-full h-[40%] bg-gradient-to-b from-white/10 to-transparent"></div>
                  </div>
                  <span className="text-[10px] text-gray-400 font-medium whitespace-nowrap absolute -bottom-6">Opt-in</span>
                </div>
              </div>
            </div>

            <div className="absolute -bottom-4 left-1/2 -translate-x-1/2 w-[80%] h-8 bg-blue-500/10 blur-xl rounded-full pointer-events-none"></div>
          </div>

          {/* Top Content Card */}
          <div className="border-white/[0.08] border rounded-[2rem] p-5 relative" style={{ backgroundColor: "#1C1C1C" }}>
            <div className="flex justify-between items-start mb-6">
              <div>
                <h2 className="text-lg font-semibold text-white tracking-tight">Ticket Sales</h2>
                <p className="text-[13px] text-gray-300 mt-1 font-medium">€ 24.580</p>
              </div>
              <button className="px-4 py-1.5 rounded-full border border-white/10 text-[11px] font-medium text-gray-300 hover:text-white transition-colors" style={{ backgroundColor: "rgba(255, 255, 255, 0.05)" }}>
                More
              </button>
            </div>

            <div className="space-y-6">
              {/* Item 1 */}
              <div className="flex gap-4 items-start group cursor-pointer">
                <div className="w-12 h-12 rounded-[10px] overflow-hidden bg-gray-800 shrink-0 shadow-lg ring-1 ring-white/5">
                  <div className="w-full h-full bg-[radial-gradient(ellipse_at_top_right,_var(--tw-gradient-stops))] from-orange-400 via-red-500 to-purple-600 scale-125 group-hover:scale-110 transition-transform duration-500"></div>
                </div>
                <div className="flex-1 min-w-0 pt-0.5">
                  <div className="flex justify-between items-center mb-2">
                    <h3 className="text-sm font-medium text-white truncate pr-2">Asset Allocation</h3>
                    <span className="text-xs font-semibold text-white">$ 157.49</span>
                  </div>
                  <div className="w-full h-1.5 rounded-full overflow-hidden" style={{ backgroundColor: "#2A2A35" }}>
                    <div
                      className="h-full bg-gradient-to-r from-blue-500 via-indigo-500 to-purple-500 rounded-full"
                      style={{
                        ["--target-width" as never]: "70%",
                        width: "70%",
                        animation: "progress-loop 3s cubic-bezier(0.4, 0, 0.2, 1) infinite",
                      }}
                    ></div>
                  </div>
                </div>
              </div>

              {/* Item 2 */}
              <div className="flex gap-4 items-start group cursor-pointer opacity-60 hover:opacity-100 transition-opacity">
                <div className="w-12 h-12 rounded-[10px] overflow-hidden bg-gray-800 shrink-0 shadow-lg ring-1 ring-white/5">
                  <div className="w-full h-full bg-[radial-gradient(ellipse_at_bottom_left,_var(--tw-gradient-stops))] from-blue-400 via-indigo-500 to-purple-600 scale-125"></div>
                </div>
                <div className="flex-1 min-w-0 pt-0.5">
                  <div className="flex justify-between items-center mb-2">
                    <h3 className="text-sm font-medium text-white truncate pr-2">Build an Interactive site</h3>
                    <span className="text-xs font-semibold text-white">$ 157.49</span>
                  </div>
                  <div className="w-full h-1.5 rounded-full overflow-hidden" style={{ backgroundColor: "#2A2A35" }}>
                    <div
                      className="h-full bg-gradient-to-r from-blue-500 to-indigo-500 rounded-full"
                      style={{
                        ["--target-width" as never]: "40%",
                        width: "40%",
                        animation: "progress-loop 3s cubic-bezier(0.4, 0, 0.2, 1) infinite 0.2s",
                      }}
                    ></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Navigation */}
        <div className="absolute bottom-0 w-full h-[90px] z-30 px-4">
          <div className="absolute inset-x-0 bottom-0 h-[80px] backdrop-blur-2xl border-t border-white/[0.08] rounded-t-[2.5rem]" style={{ backgroundColor: "rgba(18, 18, 26, 0.95)" }}></div>

          <div className="relative h-full flex items-end justify-between px-2 pb-5">
            <button className="flex flex-col items-center gap-1.5 text-white/55 hover:text-white transition-colors w-16 group mb-1 bg-transparent">
              <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="group-hover:scale-110 transition-transform">
                <rect width="7" height="7" x="3" y="3" rx="1" />
                <rect width="7" height="7" x="14" y="3" rx="1" />
                <rect width="7" height="7" x="14" y="14" rx="1" />
                <rect width="7" height="7" x="3" y="14" rx="1" />
              </svg>
              <span className="text-[10px] font-medium">Dashboard</span>
            </button>

            <button className="flex flex-col items-center gap-1.5 text-white/55 hover:text-white transition-colors w-16 group mb-1 bg-transparent">
              <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="group-hover:scale-110 transition-transform">
                <circle cx="12" cy="12" r="10" />
                <polygon points="10 8 16 12 10 16 10 8" />
              </svg>
              <span className="text-[10px] font-medium">Scanteams</span>
            </button>

            <div className="relative -top-5 flex flex-col items-center justify-center w-16 group cursor-pointer z-50">
              <div className="w-[3.5rem] h-[3.5rem] rounded-full bg-gradient-to-tr from-[#6366F1] to-[#A855F7] flex items-center justify-center shadow-[0_0_25px_rgba(139,92,246,0.5)] border-[5px] border-[#0B0F2A] group-hover:scale-105 transition-transform duration-300 ring-1 ring-white/10">
                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M3 3v18h18" />
                  <path d="m19 9-5 5-4-4-3 3" />
                </svg>
              </div>
              <span className="text-[10px] font-semibold text-white mt-2 drop-shadow-md">Analytic</span>
            </div>

            <button className="flex flex-col items-center gap-1.5 text-white/55 hover:text-white transition-colors w-16 group mb-1 bg-transparent">
              <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="group-hover:scale-110 transition-transform">
                <line x1="12" x2="12" y1="2" y2="22" />
                <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" />
              </svg>
              <span className="text-[10px] font-medium">Finance</span>
            </button>

            <button className="flex flex-col items-center gap-1.5 text-white/55 hover:text-white transition-colors w-16 group mb-1 bg-transparent">
              <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="group-hover:scale-110 transition-transform">
                <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                <circle cx="9" cy="7" r="4" />
                <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
                <path d="M16 3.13a4 4 0 0 1 0 7.75" />
              </svg>
              <span className="text-[10px] font-medium">Marketing</span>
            </button>
          </div>

          <div className="absolute bottom-2 left-1/2 -translate-x-1/2 w-32 h-1 rounded-full z-40 transition-colors" style={{ backgroundColor: "rgba(255, 255, 255, 0.2)" }}></div>
        </div>
      </div>
    </div>
  );
};

export default MobileAnalyticsDashboard;
